import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';

export const MightyNewsWrapper = styled.div`
  position: relative;
`

export const MightyNewsContainer = styled.div`
  padding: 5rem 0 7rem;
  width: 100%;

  & > h1 {
    font-size: 2.5rem;
    padding: 0 1rem;
  }

  & > div {
    max-width: 1400px;
    margin: 0 auto;
  }

  .slick-prev {
    left: -10px;
  }

  .slick-next {
    right: -10px;
  }

  .slick-dots {
    bottom: -40px;

    & > li {
      margin: 0;
    }

    & > li > div {
      background: ${palette.lightGray};
    }

    & > li.slick-active > div {
      background: ${palette.black};
    }
  }

  @media screen and (max-width: ${layout.lg}) {
    .slick-prev {
      left: 0px;
    }

    .slick-next {
      right: 0px;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding-top: 3rem;
  }
`

export const MightyNewsCompanies = styled.div`
  padding: 3rem 0;
  width: 65%;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .invest-like {
    width: 15%;
  }
  .wallstreet-journal {
    width: 35%;
    margin-top: 1rem;
  }

  @media screen and (max-width: ${layout.md}) {
    width: 100%;

    .invest-like {
      width: 15%;
    }
    .wallstreet-journal {
      width: 35%;
      margin-top: 0.5rem;
    }
  }
`

export const ImageContainers = styled.div`
  width: 25%;
  padding: 0 1rem;

  @media screen and (max-width: ${layout.md}) {
    padding: 0 0.5rem;
  }
`

export const PressSectionCarouselItem = styled.a`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  min-height: initial;
  padding: 0 20px;

  & > p {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 2em 2em 3em;
    z-index: 2;
    color: #FFFFFF;
  }

  @media screen and (max-width: ${layout.xs}) {
    padding: 0 5px;

    & > p {
      padding: 2em 2em 2em;
    }
  }

  @media screen and (max-width: ${layout.xs}) {
    padding: 0;
  }
`

export const PressImageContainer = styled.div`
  position: relative;
  max-width: 100vw;
  width: 100%;
  box-sizing: border-box;
`

export const PressImage = styled(GatsbyImage) <GatsbyImageProps>`
  height: 504px;

  @media screen and (max-width: ${layout.lg}) {
    height: 440px;
  }

  @media screen and (max-width: ${layout.sm}) {
    height: 375px;
  }

  @media screen and (max-width: ${layout.xs}) {
    height: 390px;
  }
`

export const SliderContainer = styled.div`
  & > div {
    position: relative;
    max-width: 100vw;
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 30px;
  }

  @media screen and (max-width: ${layout.sm}) {
    & > div {
      padding: 0 15px;
    }
  }

  @media screen and (max-width: ${layout.xs}) {
    & > div {
      padding: 0px;
    }
  }
`

export const DescriptionP = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  color: ${palette.white};
  padding: 0 3rem;
  white-space: pre-line;
`
